var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatascience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5685 31.7578H37.4314V38.3314H22.5685V31.7578Z",
    fill: "#687383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5685 21.6686H37.4314V28.2422H22.5685V21.6686Z",
    fill: "#687383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5022 20.9006H16.0133C15.3168 20.9006 14.6385 20.9799 13.9866 21.1289V35.324C15.3284 35.7437 16.53 36.4832 17.5022 37.4529V20.9006Z",
    fill: "#687383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7424 10.5881C20.7657 6.40652 25.0515 3.51562 30 3.51562C32.5433 3.51562 35.0043 4.30242 37.0628 5.71043C37.8816 4.78969 38.8941 4.04566 40.0359 3.54188C37.2182 1.28109 33.6761 0 30 0C23.0619 0 17.1412 4.43555 14.9223 10.6196C15.2835 10.5994 18.7424 10.5881 18.7424 10.5881Z",
    fill: "#687383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 30C60 23.6965 56.3385 18.2328 51.0311 15.6219C50.4241 16.7077 49.5898 17.6492 48.592 18.3817C53.2109 20.219 56.4844 24.7343 56.4844 30C56.4844 34.9484 53.5935 39.2342 49.4119 41.2576C49.4119 41.2576 49.4016 44.7163 49.3814 45.0773C55.5649 42.8581 60 36.9376 60 30Z",
    fill: "#687383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72695 37.0869C4.30852 35.0236 3.51563 32.5534 3.51563 30C3.51563 24.4445 7.15957 19.7249 12.1827 18.1035C13.3904 17.7136 14.6776 17.5022 16.0134 17.5022H37.3913C36.4246 16.5292 35.6876 15.3278 35.2703 13.9866H16.0133C14.6933 13.9866 13.4105 14.1483 12.1826 14.4509C5.19668 16.1724 0 22.4903 0 30C0 33.6795 1.28344 37.2246 3.54809 40.0436C4.05691 38.9068 4.80422 37.9002 5.72695 37.0869Z",
    fill: "#687383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0994 43.9867V42.4978H19.9706C20.0131 42.8437 20.0374 43.1952 20.0374 43.5525C20.0374 44.4075 19.9105 45.2331 19.6776 46.0134H38.8696C39.0189 45.3614 39.0994 44.6833 39.0994 43.9867Z",
    fill: "#687383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0135 43.9867V19.6763C45.2187 19.9187 44.376 20.0502 43.5029 20.0502C43.1627 20.0502 42.8278 20.0282 42.4978 19.9897V43.9867C42.4978 45.9837 42.0263 47.8724 41.1898 49.5484C39.1397 53.6561 34.8942 56.4844 30 56.4844C24.742 56.4844 20.2324 53.2203 18.3899 48.6122C17.661 49.6138 16.7222 50.4524 15.6382 51.0639C18.2556 56.3536 23.7095 60 30 60C36.875 60 42.7515 55.6446 45.0168 49.5484C45.6608 47.8151 46.0135 45.9414 46.0135 43.9867Z",
    fill: "#687383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.418 48.7735C14.3016 48.7735 16.6391 46.436 16.6391 43.5525C16.6391 40.669 14.3016 38.3314 11.418 38.3314C8.53454 38.3314 6.19699 40.669 6.19699 43.5525C6.19699 46.436 8.53454 48.7735 11.418 48.7735Z",
    fill: "#687383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5029 16.6518C46.3864 16.6518 48.724 14.3142 48.724 11.4307C48.724 8.5472 46.3864 6.20966 43.5029 6.20966C40.6194 6.20966 38.2819 8.5472 38.2819 11.4307C38.2819 14.3142 40.6194 16.6518 43.5029 16.6518Z",
    fill: "#687383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatascience);
export default __webpack_public_path__ + "static/media/Datascience.008a4d20fdfee2b8d27f9343edcbe7d4.svg";
export { ForwardRef as ReactComponent };